import { render } from "./operationManual.vue?vue&type=template&id=285575aa&scoped=true"
import script from "./operationManual.vue?vue&type=script&lang=js"
export * from "./operationManual.vue?vue&type=script&lang=js"

import "./operationManual.vue?vue&type=style&index=0&id=285575aa&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-285575aa"

export default script